import React from 'react';

interface ScorecardContextType {
  scorecard: Scorecards.Scorecard;
  updateScorecard: (updatedScorecard: Scorecards.Scorecard) => Promise<void>;
  periods: Period[];
  // periods split around today; a period is in the future when it starts after today
  pastPeriods: Period[];
  futurePeriods: Period[];
  selectedPeriods: Period[];
  setSelectedPeriods: React.Dispatch<React.SetStateAction<Period[]>>;
  isLoading: boolean;
  data?: Goals.MetricResult[];
  poppedUpKpi?: Scorecards.ScorecardKpi | Scorecards.ManualKpiRow;
  setPoppedUpKpi: React.Dispatch<
    React.SetStateAction<
      Scorecards.ScorecardKpi | Scorecards.ManualKpiRow | undefined
    >
  >;
  isAddKpiEnabled?: boolean;
  isDragAndDropEnabled?: boolean;
  isKpisDisabled?: boolean;
  isMenuEnabled?: boolean;
  // Drawn on a dashboard: the last few periods only, without click-through
  isOnDashboard: boolean;
  toIsoDate: (
    date: Scorecards.WeekDate | Scorecards.IsoDate,
  ) => Scorecards.IsoDate;
  kpisListDivRef: React.MutableRefObject<HTMLDivElement | null>;
  kpisListDivParentScrollerRef: React.MutableRefObject<HTMLDivElement | null>;
  manualKpiIdBeingEdited: string | undefined;
  setManualKpiIdBeingEdited: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  highlightKpi: (kpiId: string) => void;
  kpiBeingHighlighted: string | undefined;
  hoveredKpiId: string | undefined;
  setHoveredKpiId: React.Dispatch<React.SetStateAction<string | undefined>>;
  quickFilters: LegacySavedFilter[];
  selectedQuickFilters: LegacySavedFilter[];
  setSelectedQuickFilters: React.Dispatch<
    React.SetStateAction<LegacySavedFilter[]>
  >;
}

const ScorecardContext = React.createContext<ScorecardContextType>(
  {} as ScorecardContextType,
);

export default ScorecardContext;
